<ul class="layout-menu">
    <ng-container *ngFor="let item of model; let i = index;">
        <app-menu-item *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></app-menu-item>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>
